var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 26,
    viewBox: "0 0 4 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99971 8.3999C2.21188 8.3999 2.41536 8.52633 2.56539 8.75137C2.71542 8.97642 2.79971 9.28164 2.79971 9.5999V23.9999C2.79971 24.3182 2.71542 24.6234 2.56539 24.8484C2.41536 25.0735 2.21188 25.1999 1.99971 25.1999C1.78753 25.1999 1.58405 25.0735 1.43402 24.8484C1.28399 24.6234 1.19971 24.3182 1.19971 23.9999V9.5999C1.19971 9.28164 1.28399 8.97642 1.43402 8.75137C1.58405 8.52633 1.78753 8.3999 1.99971 8.3999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77772 1.62199L3.13127 1.26843L2.77772 1.62199C2.98401 1.82828 3.0999 2.10807 3.0999 2.3998C3.0999 2.69154 2.98401 2.97133 2.77772 3.17762C2.57143 3.38391 2.29164 3.4998 1.9999 3.4998C1.70816 3.4998 1.42838 3.38391 1.22208 3.17762L0.868531 3.53118L1.22208 3.17762C1.01579 2.97133 0.899902 2.69154 0.899902 2.3998C0.899902 2.10807 1.01579 1.82828 1.22208 1.62199C1.42837 1.4157 1.70816 1.2998 1.9999 1.2998C2.29164 1.2998 2.57143 1.4157 2.77772 1.62199Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.2a286a74a7a518f2757b22bfdd3f6be0.svg";
export { ForwardRef as ReactComponent };